export const getSubjectColumnClassName = (code: string) =>
  `teacher-subject-column-${code.replace(/[^a-z0-9]/gi, '-').toLowerCase()}`;

export const getSubjectCellClassName = (code: string) => `${getSubjectColumnClassName(code)}-cell`;

export const buildSubjectColumnStyles = (subjectColumns: string[]) => {
  if (!subjectColumns.length) {
    return '';
  }

  return subjectColumns
    .map((code) => {
      const columnClass = getSubjectColumnClassName(code);
      const cellClass = getSubjectCellClassName(code);
      return `
        .teachers-subject-matrix .${columnClass}:hover,
        .teachers-subject-matrix .${columnClass}:focus-visible,
        .teachers-subject-matrix .${cellClass}:hover,
        .teachers-subject-matrix .${cellClass}:focus-visible,
        .teachers-subject-matrix:has(.${cellClass}:hover) .${columnClass},
        .teachers-subject-matrix:has(.${cellClass}:focus-visible) .${columnClass},
        .teachers-subject-matrix:has(.${cellClass}:hover) .${cellClass},
        .teachers-subject-matrix:has(.${cellClass}:focus-visible) .${cellClass} {
          background: var(--chakra-colors-gray-100);
        }
      `;
    })
    .join('');
};
